<template>
  <div id="screen-meta" class="metabox-prefs">
    <div v-if="show" id="contextual-help-wrap" class="no-sidebar">
      <form id="adv-settings" method="post">
        <fieldset v-if="Object.keys(cols).length > 3" class="metabox-prefs">
          <legend>Columns</legend>
          <label v-for="(col, index) in cols" :key="index" v-show="index != 'cb'">
            <input v-if="index != 'cb'" class="hide-column-tog" name="table[cols][]" type="checkbox" :value="index" :checked="hiddenCols.indexOf(index) == -1 || col.default" @change="handleChangeHiddenCol" :disabled="col.default" /><span>{{ col.text }}</span>
          </label>
        </fieldset>
        <fieldset class="screen-options">
          <legend>Pagination</legend>
          <label>Number of items per page</label>
          <input type="number" step="1" min="10" max="100" class="screen-per-page" name="table[per_page]" :value="perPage" @change="handleChangePerPage" />
        </fieldset>
        <button name="screen-options-apply" id="screen-options-apply" class="btn btn-outline-success" value="Apply" @click.prevent="handleSubmitScreenOptions">Apply</button>
      </form>
    </div>
    <div v-if="!isSubOrder" id="screen-meta-links">
      <div id="screen-options-link-wrap" class="hide-if-no-js screen-meta-toggle">
        <button type="button" id="show-settings-link" class="button show-settings" aria-controls="screen-options-wrap" aria-expanded="false" @click.stop.prevent="$emit('toggleScreenOptions')">Screen Options<i :class="`ti ti-chevron-${!show ? 'down' : 'up'}`"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    show() {
      return this.config?.show || false
    },
    cols() {
      return this.config?.cols || {}
    },
    isSubOrder() {
      return this.config?.isSubOrder || false
    },
    screenOptions() {
      return this.config?.screenOptions || {}
    },
    hiddenCols() {
      return this.screenOptions.hidden_cols || []
    },
    perPage() {
      return this.screenOptions.per_page || 20
    }
  },
  methods: {
    handleChangeHiddenCol(e) {
      let index = e.currentTarget.value
      let hiddenCols = this.hiddenCols
      if (e.currentTarget.checked) {
        hiddenCols.push(index)
      } else if (hiddenCols.indexOf(index) != -1) {
        hiddenCols.splice(hiddenCols.indexOf(index), 1)
      }
      this.store.commit('screen_options.hidden_cols', hiddenCols)
    },
    handleChangePerPage(e) {
      this.store.commit('screen_options.per_page', e.currentTarget.value)
    },
    handleSubmitScreenOptions() {
      this.$util.post(`user/update-option`, this.screenOptions, this.$refs.updateOptionContainer).then((response) => {
        if (response.status == 'success') {
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
#screen-meta {
  position: absolute;
  top: 0;
  right: 0;
  margin: -1px 30px 0;
  width: calc(100% - 60px);
  background: #fff;
  border: 1px solid #ccd0d4;
  border-top: none;
  box-shadow: 0 0 0 transparent;
  z-index: 999;
  border-bottom-left-radius: var(--border-radius, 0.25rem);
  #contextual-help-wrap {
    padding: 20px;
    label {
      display: inline-block;
      padding-right: 15px;
      line-height: 2.35;
    }
    input[type='checkbox'],
    input[type='radio'] {
      border: 1px solid #7e8993;
      border-radius: 4px;
      background: #fff;
      color: #555;
      clear: none;
      cursor: pointer;
      display: inline-block;
      line-height: 0;
      height: 1rem;
      margin: -0.25rem 0.25rem 0 0;
      outline: 0;
      padding: 0 !important;
      text-align: center;
      vertical-align: middle;
      width: 1rem;
      min-width: 1rem;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      transition: 0.05s border-color ease-in-out;
      &:checked::before {
        display: inline-block;
        vertical-align: middle;
        width: 1rem;
        speak: never;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
    input[type='checkbox'] {
      margin: -4px 5px 0 0;
      &:checked::before {
        content: url(data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2020%2020%27%3E%3Cpath%20d%3D%27M14.83%204.89l1.34.94-5.81%208.38H9.02L5.78%209.67l1.34-1.25%202.57%202.4z%27%20fill%3D%27%231e8cbe%27%2F%3E%3C%2Fsvg%3E);
        margin: -0.1875rem 0 0 -0.25rem;
        height: 1.3125rem;
        width: 1.3125rem;
      }
    }
    input[type='number'] {
      padding: 0 8px;
      line-height: 2;
      min-height: 30px;
      box-shadow: 0 0 0 transparent;
      border-radius: 4px;
      border: 1px solid #7e8993;
      background-color: #fff;
      color: #32373c;
      border-radius: var(--border-radius, 0.25rem);
    }
  }
  #screen-meta-links {
    position: absolute;
    right: -1px;
  }
  .show-settings {
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid #ccd0d4;
    border-top: none;
    margin-bottom: 0;
    padding: 3px 6px 3px 16px;
    border-radius: 0 0 var(--border-radius, 0.25rem) var(--border-radius, 0.25rem);
    color: #72777c;
    background: #fff;
    line-height: 1.7;
  }
}
</style>
